@if (!user) {
<div class="dashboard-reload">
  <button (click)="reload()" class="btn btn-light btn-lg dashboard-reload-btn" type="button">
    <em class="fal fa-redo"></em>
    Cliquez pour recharger
  </button>
</div>
} @if (user) {
<div class="dashboard-body">
  <mir-sqrs-broadcast [login]="false"></mir-sqrs-broadcast>
  <mir-active-announces-banner></mir-active-announces-banner>
  <mir-shortcuts-bar [user]="user" [version]="version"></mir-shortcuts-bar>
  <mir-today-events-banner [user]="user" [version]="version"></mir-today-events-banner>
  <mir-did-you-know></mir-did-you-know>
  <mir-my-appointments [user]="user" [version]="version"></mir-my-appointments>
  <mir-sdis-activity [user]="user" [version]="version"></mir-sdis-activity>
</div>
}
